import { LinkIcon, BookmarkIcon } from '@heroicons/react/solid';

import { Tag } from './Tag';

type TableProps<Data extends Array<unknown>> = {
  data: Data;
  renderRow: (rowData: Data[number]) => React.ReactElement;
  handleClick: (rowData: Data[number]) => void;
};

const TableActions = ({ url }: { url: string }) => {
  const handler = (
    e: React.MouseEvent<HTMLTableCellElement, MouseEvent>,
    func: () => void,
  ) => {
    e.stopPropagation();

    if (typeof func !== 'function')
      throw new Error('Please supply a function for parameter `func`');

    func();
  };

  return (
    <>
      <td
        className="table-col"
        onClick={(e) => handler(e, () => console.log('should copy the link'))}
        style={{
          paddingLeft: '8px!important',
          paddingRight: '8px!important',
        }}
      >
        <div className="flex justify-center items-center">
          <LinkIcon className="h-6 w-6" />
        </div>
      </td>
      <td
        className="table-col"
        onClick={(e) =>
          handler(e, () => console.log('should bookmark the link'))
        }
        style={{
          paddingLeft: '8px!important',
          paddingRight: '8px!important',
        }}
      >
        <div className="flex justify-center items-center">
          <BookmarkIcon className="h-6 w-6" />
        </div>
      </td>
    </>
  );
};

export function Table<T extends Array<unknown>>({
  data,
  renderRow,
  handleClick,
}: TableProps<T>) {
  return (
    <table className="default-table">
      <thead className="absolute">
        <tr>
          <th className="w-3/4 md:w-7/12" />
          <th className="w-1/4 md:w-3/12" />
          <th className="w-0 md:w-1/12" />
          <th className="w-0 md:w-1/12" />
        </tr>
      </thead>
      <tbody>
        {data.map((item, i) => (
          <tr
            key={item.id}
            className="table-row"
            onClick={() => handleClick(item)}
          >
            {typeof renderRow === 'function' && renderRow(item)}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

Table.Cell = ({
  className = '',
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) => <td className={`table-col truncate ${className ?? ''}`}>{children}</td>;

Table.Actions = TableActions;
Table.Tag = Tag;
